module.exports = __webpack_public_path__ + "img/Najarian.48fdd61a.jpg";